// .pen hfPqb(FB0fg) / nTAQE(KkJt4) SettingsSection priceRow — 创建页与资源包设置页共用。
import { CircleDollarSign } from 'lucide-react'

export function PackPriceRow({
  value,
  min,
  onChange,
  inputId = 'pack-price-input',
}: {
  value: number
  min: number
  onChange: (v: number) => void
  inputId?: string
}) {
  return (
    <section data-testid="hfPqb" className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-4">
        <label
          htmlFor={inputId}
          className="shrink-0 text-[16px] font-medium text-[#1A1A1A]"
        >
          价格（金币）
        </label>
        <div className="flex min-w-0 flex-1 items-center gap-1.5 rounded-[10px] bg-[#F6F7F8] px-3.5 py-2">
          <CircleDollarSign size={18} className="shrink-0 text-[#F5B300]" aria-hidden="true" />
          <input
            id={inputId}
            data-testid={inputId}
            type="number"
            min={min}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            className="w-full bg-transparent text-right text-[18px] font-semibold tabular-nums text-[#1A1A1A] outline-none"
          />
        </div>
      </div>
      {value < min && (
        <p className="text-[11px] text-[#FF6B6B]">价格不得低于 {min} 金币</p>
      )}
    </section>
  )
}
